
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import PropTypes from 'prop-types';

function GameVideo (props) {
    return Template.default.apply({props}); //eslint-disable-line no-undef
}

GameVideo.propTypes = {
    streamURL: PropTypes.string,
    loggedIn: PropTypes.bool,
    balance: PropTypes.number
};

export default GameVideo;